import { Injectable, inject } from '@angular/core';
import { PublicIssueApiService } from '../api/services/public-issue-api.service';
import { Observable, tap } from 'rxjs';
import { PublicIssueForm } from '../models/public-issue-form';
import { PublicIssueCreateRequest } from '../api/requests/public-issue-create.request';
import { PublicIssueComplaintRequest } from '../api/requests/public-issue-complaint.request';
import { blank, executeOrNull, valueOrDefault } from '@web/utils';
import { ToastService } from '@web/shared/ui';
import { PublicIssueFileRequest } from '../api/requests/public-issue-file.request';

@Injectable({
  providedIn: 'root',
})
export class PublicIssueDataSourceService {
  private readonly publicIssueApi = inject(PublicIssueApiService);
  private readonly toast = inject(ToastService);

  public createIssueByFormData(data: PublicIssueForm): Observable<void> {
    return this.publicIssueApi
      .createIssue(
        new PublicIssueCreateRequest({
          acceptRules: data.acceptRules,
          complaint: executeOrNull(
            data.complaint,
            (complaint) =>
              new PublicIssueComplaintRequest({
                files: valueOrDefault(complaint.fileIds, []).map(
                  (id) => new PublicIssueFileRequest({ id }),
                ),
                orderNumber: complaint.orderNumber,
                reasons: complaint.reasons,
              }),
          ),
          dignity: data.dignity,
          email: data.email,
          message: data.message,
          type: data.type,
          phone: data.phone,
        }),
      )
      .pipe(
        tap({
          next: () =>
            this.toast.show((builder) =>
              builder
                .initSuccess('Zgłoszenie zostało wysłane pomyślne.')
                .build(),
            ),
          error: () =>
            this.toast.show((builder) =>
              builder
                .initError(
                  'Nie udało się wysłać zgłoszenia. Proszę poprawić błędy w formularzu.',
                )
                .build(),
            ),
        }),
        blank(),
      );
  }
}
